<template>
  <div class="ordersNew" :class="`ordersNew ${$store.state.isMobile ? 'ordersNew_mobile' : ''}`" @click="clickPage">
    <mobileBack class="topTitleBack"
      :style="`background-color: #FFFDFA;${$route.query.orderType == 2 ? 'padding-left: 0.25rem' : 'padding-left: 0.05rem'}`"
      v-if="$store.state.isMobile"></mobileBack>
    <div v-if="$store.state.isMobile" style="margin-top: -0.3rem;min-height: calc(100vh - 4rem); padding-bottom:1.8rem">
      <tabs :tabs="$route.query.orderType == 1 ? ['待使用', '已使用', '已取消', '已过期', '未提交'] : ['待使用', '已使用', '已取消', '已过期']">
        ></tabs>
      <div class="mobileContent">
        <personalCard type="line" v-for="item in orders" :key="item.orderId" v-show="orders.length"
          :class="`orderStatus_${item.orderStatus}`">
          <div slot="left" :class="`leftName orderStatus_${item.orderStatus}`">
            {{ $store.state.ticketDetail.ticketName }}
          </div>
          <div slot="right" :class="`rightContent orderStatus_${item.orderStatus}`">
            <div class="detail">
              <span class="title">预约时间</span>
              <span class="name">{{ item.bookingDate }}（{{ item.timeRange }}）</span>
            </div>
            <div class="detail" v-if="item.peopleCount">
              <span class="title">参观人数</span>
              <span class="name">{{ item.peopleCount }}人</span>
            </div>
            <div class="detail" v-if="item.orgName">
              <span class="title">团队名称</span>
              <span class="name">{{ item.orgName }}</span>
            </div>
            <div class="buttonsWarp">
              <div class="buttonCancel" @click="showOrderDetail('cancel', item.orderId, item.orderStatus, item)"
                v-if="item.orderStatus == 1 && !($route.query.orderType == 1 && activeTabIndex == 4)">取消</div>
              <!-- 未提交订单的删除 -->
              <div class="buttonCancel" @click="delOrderById(item.orderId)"
                v-if="!(item.orderStatus == 3 && item.orderType == 2) && activeTabIndex == 4">删除</div>
              <!-- <div class="buttonCancel" @click="delOrderById2(item.orderId)" v-if="activeTabIndex == 2 || activeTabIndex == 3 || activeTabIndex == 1 || (activeTabIndex == 0 && item.auditState == 2)">删除</div> -->
              <div class="buttonConfirm" @click="showOrderDetail('look', item.orderId, activeTabIndex + 1, item)"
                v-if="!(activeTabIndex == 4 && item.orderStatus == 4)">查看</div>
            </div>
            <!-- <div v-if="item.orderType == 1" class="tuan"></div> -->
          </div>
          <div slot="status">
            <!-- 待提交的 审核的 -->
            <!-- <div
              :class="`orderStatus ${$route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 1 ? `status_${item.auditState}` : ''}`">
              {{ $route.query.orderType == 1 && activeTabIndex == 1 && item.orderStatus == 1 ? '待提交' :
                ($route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 1 ? auditStates[item.auditState]
                  : orderStatus[item.orderStatus - 1]) }}</div> -->
            <!-- <div :class="`orderStatus ${$route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 1 ? `status_${item.auditState}` : ''}`">{{($route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 1 ? auditStates[item.auditState] : '')}}</div> -->
            <div class="orderStatus">{{ $route.query.orderType == 1 && activeTabIndex == 4 ?
    '待提交' : ($route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 4 ?
      auditStates[item.auditState] : orderStatus[item.orderStatus - 1]) }}</div>

          </div>
        </personalCard>
        <div class="noData" v-if="!orders.length">暂无数据</div>
      </div>
      <h5Bottom></h5Bottom>
    </div>
    <div v-else>
      <topBanner></topBanner>
      <div class="pcBg"></div>
      <div class="pcContent">
        <div class="pcGroup">
          <div class="pcToIndex" @click="backPersonCenter">返回</div>
          <div class="pcTitle">{{ $route.query.orderType == 1 ? '团队订单' : '个人订单' }}</div>
        </div>
        <!-- <pcTabs2 :reservationType="1"></pcTabs2> -->
        <!-- <pcTabs :tabs="$route.query.orderType == 1 ? ['团队订单', '未提交订单'] : ['个人订单']"></pcTabs> -->
        <div class="pcItemCard">
          <pcTabs
          ref="tabsPc"
            :tabs="$route.query.orderType == 1 ? ['待使用', '已使用', '已取消', '已过期', '未提交'] : ['待使用', '已使用', '已取消', '已过期']">
          </pcTabs>
          <div class="personals">
            <personalCard type="line" v-for="item in orders" :key="item.orderId" v-show="orders.length"
              :class="`orderStatus_${item.orderStatus}`">
              <div slot="left" :class="`leftName orderStatus_${item.orderStatus}`">
                {{ $store.state.ticketDetail.ticketName }}
              </div>
              <div slot="right" :class="`rightContent orderStatus_${item.orderStatus}`">
                <div class="detail">
                  <span class="title">预约时间</span>
                  <span class="name">{{ item.bookingDate }}（{{ item.timeRange }}）</span>
                </div>
                <div class="detail" v-if="item.peopleCount">
                  <span class="title">参观人数</span>
                  <span class="name">{{ item.peopleCount }}人</span>
                </div>
                <!-- <div class="detail" v-show="$route.query.orderType == 2">
                  <span class="title" style="margin-right: 37px;">参观人</span>
                    <div v-for="(people, pIndex) in item.peoples.filter((i, pi) =>{return pi < 3})" :key="`${people.peopleId}_${people.orderId}`" class="peoples">
                    <div>{{people.peopleName}}{{item.peoples.length > 3 && pIndex == 2 ? '...' : ''}}</div>
                  </div>
                </div> -->
                <div class="detail" v-if="item.orgName">
                  <span class="title">团队名称</span>
                  <span class="name">{{ item.orgName }}</span>
                </div>
                <div class="buttonsWarp">
                  <div class="buttonCancel" @click="showOrderDetail('cancel', item.orderId, item.orderStatus, item)"
                    v-if="item.orderStatus == 1 && !($route.query.orderType == 1 && activeTabIndex == 4) && item.auditState != 2">
                    取消</div>
                  <!-- 未提交订单的删除 -->
                  <div class="buttonCancel" @click="delOrderById(item.orderId)"
                    v-if="!(item.orderStatus == 3 && item.orderType == 2) && activeTabIndex == 4">删除</div>
                  <!-- <div class="buttonCancel" @click="delOrderById2(item.orderId)" v-if="activeTabIndex == 2 || activeTabIndex == 3 || activeTabIndex == 1 || (activeTabIndex == 0 && item.auditState == 2)">删除</div> -->
                  <div class="buttonConfirm" @click="showOrderDetail('look', item.orderId, activeTabIndex + 1, item)"
                    v-if="!(activeTabIndex == 4 && item.orderStatus == 4)">查看</div>
                </div>
                <!-- <div v-if="item.orderType == 1" class="tuan"></div> -->
              </div>
              <div slot="status">
                <div class="orderStatus">{{ $route.query.orderType == 1 && activeTabIndex == 4 ?
    '待提交' : ($route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 4 ?
      auditStates[item.auditState] : orderStatus[item.orderStatus - 1]) }}</div>

                <!-- <div :class="`orderStatus ${$route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 1 ? `status_${item.auditState}` : ''}`">{{($route.query.orderType == 1 && item.auditState != 4 && item.orderStatus == 1 ? auditStates[item.auditState] : '')}}</div> -->
              </div>
            </personalCard>
            <div class="noData" v-if="!orders.length">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="$store.state.isMobile ? '' : 'pcContent'" v-if="showPop">
      <pop>
        <slot>
          <div class="confirmText">您确定要删除吗？</div>
          <div class="buttonsWarp">
            <div class="buttonCancel" @click="cancel">取消</div>
            <div class="buttonConfirm" @click="confirm">确定</div>
          </div>
        </slot>
      </pop>
    </div>
  </div>
</template>

<script>
import tabs from '../../components/common/tabs.vue'
import pcTabs from '../../components/common/pcTabs.vue'
import personalCard from '../../components/common/personalCard.vue'
import topBanner from '../../components/common/topBanner'
// import pcTabs2 from '../../components/ticket/pcTabs'
import pop from '../../components/common/pop'
import mobileBack from '../../components/common/mobileBack'
import h5Bottom from '../../components/common/h5Bottom.vue'
import PcTabs from '../../components/common/pcTabs.vue'
var msg
export default {
  data() {
    return {
      orders: [],
      activeTabIndex: 0,
      showPop: false,
      orderStatus: ['待使用', '已使用', '已取消', '已过期', '未提交'],
      auditStates: ['未审核', '通过审核', '未通过审核', '无需审核'],
      orderPeoples: [],
      delItem: {},
      allPeoples: []
      // orderStatusKey:4
    };
  },

  components: { tabs, personalCard, pcTabs, topBanner, pop, mobileBack, h5Bottom },

  methods: {
    activeTab(index) {
      this.activeTabIndex = index
      console.log('index')
      console.log(index)
      sessionStorage.setItem('activeTabIndex', index)
      this.getOrders(index)
    },

    // 返回个人中心
    backPersonCenter() {
      this.$router.push({ name: 'personalCenter', query: this.$route.query })
    },

    cancel() {
      this.showPop = false
    },
    clickPage() {
      if (msg) {
        msg.close()
        this.$message.close()
      }
    },

    confirm() {
      this.showPop = false
      this.delOrderById(this.delItem.id)
    },

    // 删除订单、仅限未提交订单
    delOrderById(id) {
      console.log(id)
      this.$ajax.delete(`/api/ticket/front/order/temp-order?id=${id}`).then((res) => {
        // console.log('res')
        // console.log(res)
        this.$message.success({ message: '删除成功', showClose: true, duration: 1000 })
        this.getOrders(4)
      })
    },

    showOrderDetail(type, id, status, item) {
      let query = this.$route.query
      query.orderId = id
      query.orderStatus = status
      console.log(type)
      console.log(id)
      console.log(status)
      console.log(item)
      console.log('query')
      console.log(query)
      if (type == 'look' && status == 5) {
        query.belongId = item.peopleId
        return this.$router.push({ name: 'groupDetail', query })
      }
      if (type == 'look' && status != 5) return this.$router.push({ path: '/ticket/re_success', query })
      query.type = type
      this.$route.query.id ? query.id = this.$route.query.id : ''
      this.$router.push({ path: '/ticket/orderDetail', query })

    },

    delOrder(id) {
      this.showPop = true
      this.delItem.id = id
    },

    getOrders(status) {
      // this.orders = []
      // this.orderPeoples = []
      // let url = ""
      // console.log('status')
      // console.log(status)
      // if (this.$store.state.isMobile) {
      //   url = (status && this.$route.query.orderType == 1) ? `/api/ticket/front/order/my-temp-order` : `/api/ticket/front/order/my-order?museumCode=${this.$route.query.museumCode}&orderType=${this.$route.query.orderType || 2}${this.$route.query.id ? `&ticketId=${this.$route.query.id}` : ''}`
      // } else {
      //   if (status < 4) {
      //     url = `/api/ticket/front/order/my-order?museumCode=${this.$route.query.museumCode}&orderType=${this.$route.query.orderType || 2}${this.$route.query.id ? `&ticketId=${this.$route.query.id}` : ''}&orderStatus=${status ? status + 1 : 1}`
      //   } else {
      //     console.log('122334')
      //     url = `/api/ticket/front/order/my-temp-order`
      //   }
      // }
      this.orders = []
      this.orderPeoples = []
      let url = (status == 4 && this.$route.query.orderType == 1) ? `/api/ticket/front/order/my-temp-order` : `/api/ticket/front/order/my-order?museumCode=${this.$route.query.museumCode}&orderType=${this.$route.query.orderType || 2}${this.$route.query.id ? `&ticketId=${this.$route.query.id}` : ''}&orderStatus=${status + 1}`
      this.$ajax(url).then((res) => {
        res.data.map((item) => {
          item.bookingDate = item.bookingDate.replaceAll('-', '/').split(' ')[0]
          item.timeRange = item.timeRange.replace(':00-', '-').substring(0, 11)
          let orderItemIndex = this.orderPeoples.findIndex((o) => { return item.orderId == o.orderId })
          console.log(status, 'status')
          if (orderItemIndex == -1 && (item.orderStatus == this.activeTabIndex + 1 || status == 4)) { //没有订单
            this.orderPeoples.push(item)
          } else if (this.activeTabIndex + 1 == 1 && orderItemIndex > -1 && this.orderPeoples[orderItemIndex].orderStatus != 1 && orderItemIndex > -1) {
            this.orderPeoples.splice(orderItemIndex, 1, item)
          }
        })
        this.orders = this.orderPeoples.map((item) => {
          item.peoples = res.data.filter((o) => { return o.orderId == item.orderId && (o.orderStatus == this.activeTabIndex + 1 || status == 4) })
          return item
        })
        console.log(this.orders)
      })

      // this.$ajax(url).then((res) => {
      //   if (status == 0) {
      //     this.allPeoples = res.data
      //     console.log('allPeoples')
      //     console.log(this.allPeoples)
      //   }
      //   res.data.map((item) => {
      //     item.bookingDate = item.bookingDate.replaceAll('-', '/').split(' ')[0]
      //     item.timeRange = item.timeRange.replace(':00-', '-').substring(0, 11)
      //     let orderItemIndex = this.orderPeoples.findIndex((o) => { return item.orderId == o.orderId })

      //     if (!(status >= 0 && this.$route.query.orderType && item.orderStatus == 4) || status >= 0) {
      //       if (status >= 0) { //没有订单
      //         this.orderPeoples.push(item)
      //       }
      //       else if (item.orderStatus == 1 && this.orderPeoples[orderItemIndex].orderStatus != 2) {
      //         this.orderPeoples.splice(orderItemIndex, 1, item)
      //       }
      //     }
      //   })
      //   // this.orders = this.orderPeoples.filter(item => !item.belongId)
      //   this.orders = this.orderPeoples.filter(item => !item.belongId)
      //   if (status == 4) {
      //     this.orders.forEach(item => item.orderStatus = 4)
      //   }

      //   if (status == 2) {
      //     let result=[]
      //     this.allPeoples.forEach(item => {

      //       this.orders.forEach((o,index)=> {

      //         if (item.orderStatus == 3&&o.orderId==item.orderId&&item.belongId===o.peopleId) {
      //           this.orders.splice(index,1)
      //           this.orders.push(item)
      //         }
      //       })

      //     })
      //     console.log(this.orders)
      //   }

      //   this.orders.sort((a, b) => a.orderStatus - b.orderStatus)
      // })
    },

    getTicketDetail() {
      if (this.$store.state.ticketDetail.id) {
        return
      }
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$route.query.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax.get(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
        console.log('ticketDetail')
        console.log(this.$store.state.ticketDetail)
      })
    },
  },

  created() {
    let index = sessionStorage.getItem('activeTabIndex')
    if (index) {
     
      // this.$ref.tabsPc.active(index)
    } else {
      this.getOrders(0)
    }
    this.getTicketDetail()

  },
  mounted() {
    console.log()
  },
  computed: {

  }
}
</script>

<style scoped lang="scss">
.ordersNew {
  &.ordersNew_mobile {
    .mobileContent {
      min-height: calc(100vh - 5.3rem);
      padding-top: 0.1rem;
      padding-bottom: 0.65rem;

      .personalCard:first-child {
        margin-top: 0
      }
    }

    .buttonsWarp {
      div {
        width: 2.5rem;
        margin-left: 0.5rem;
        margin-right: 0.4rem;
      }
    }
  }

  .detail {
    .title {
      margin-right: 0.3rem;
    }
  }

  .confirmText {
    margin: 0.5rem 0;
    font-size: 0.6rem;
    font-weight: 500;
  }

  .pcItemCard {
    margin-top: 40px;

    .personals {
      display: flex;
      margin-bottom: 200px;
    }
  }

  .noData {
    margin-top: 1rem;
    text-align: center;
    width: 100vw;
    font-size: 0.5rem;
  }

  .pcContent {
    .noData {
      font-size: 30px;
    }

    .pcGroup {
      display: flex;
      align-items: center;

      .pcTitle {
        color: #333;
        font-family: FZDaBiaoSong-B06S;
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 3.2px;
        width: calc(100% - 180px);
      }
    }

    .backPersonCenter {
      width: 150px;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      text-align: center;
      margin: 0;
      margin-left: 1050px;
    }

    .pcItemCard {
      margin-top: 30px !important;
    }
  }
}
</style>
<style type="text/css" lang="scss">
.ordersNew {
  &.ordersNew_mobile {
    .tabs {
      padding-top: 0;

      .normalTab {
        color: #33333399;
      }
    }
  }

  // .orderStatus_4{
  //   opacity: 0.6;
  // }
  .rightContent {
    opacity: 1;
  }

  .rightContent.orderStatus_4 .detail {
    opacity: 0.6;
  }

  .personalCard {
    display: block !important;
    border: unset;
    border-radius: 0.26rem !important;
    overflow: hidden !important;
    padding: 0 !important;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.05);
    margin: 0.65rem 0.5rem !important;
    background: #fff;

    .leftLine {
      min-height: unset !important;
      max-height: unset;
      max-width: unset;
      width: calc(100% - 1rem) !important;
      text-align: left;
      padding: 0.26rem 0.52rem;
      background: #C9C9C9;
      border: 0;

      // border-top-left-radius: 0.26rem;
      // border-top-right-radius: 0.26rem;
      .leftName {
        height: auto;
        display: block;
        max-width: unset;
        font-size: 0.44rem;
        color: #fff;
        width: 6rem;
        margin: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    &.orderStatus_1 .right .detail {
      opacity: 1 !important;

      .title {
        color: #33333366;
      }
    }

    .right {
      margin-top: 0.34rem;

      .rightContent {
        width: 100%;
      }

      .detail {
        padding-left: 0.52rem;
        opacity: 0.5;
        font-size: 0.416rem;

        .name {
          font-size: 0.42rem;
        }
      }

      .buttonsWarp {
        width: 100%;
        position: relative;
        justify-content: center;
        padding: 0.3rem 0 0.26rem 0;
        margin-top: 0.1rem;
        border-top: 0.02rem dashed #0000001a;

        &:after,
        &:before {
          position: absolute;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #f8f5f0;
          content: '';
          display: inline-block;
          top: -10px;
          left: -10px;
        }

        &:before {
          right: -10px;
          left: unset;
        }

        div {
          margin: 0 0.65rem;
          width: 2.2rem;
          letter-spacing: 0.275em;
          padding-left: 0.1rem;
        }
      }
    }

    .orderStatus {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 0.365rem;
      height: 0.83rem;
      line-height: 0.83rem;
      top: 0.16rem;
      right: 0.1rem;
      width: 2.23rem;
      border-radius: 0.26rem 0.26rem 0px 0px;

      &.status_0 {
        //未审核
        background: #fff;
        color: #93723B;
      }

      &.status_1 {
        //通过审核
        color: #3F6F51;
        background: #fff;
      }

      &.status_2 {
        //未通过审核
        color: #5F2B2A;
        background: #fff;
      }
    }

    .leftName {
      writing-mode: unset;
    }
  }

  // pc
  .pcItemCard {
    .personalCard {
      box-shadow: 0px 2px 20px rgba(66, 55, 57, 0.2);
      margin: 30px 0 !important;
      overflow: hidden;
      border-radius: 15px !important;

      &.orderStatus_1 {
        .leftLine {}
      }

      .leftLine {
        padding: 0;
        padding: 15px 0;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100% !important;
        max-width: unset;
        border: 0;
        background: #931d1b0d;
      }

      .leftName {
        font-size: 20px !important;
        max-width: unset !important;
        height: auto !important;
        line-height: 26px !important;
        letter-spacing: 0.1em;
        opacity: 1 !important;
        color: #333;
        width: 260px;
        padding: 0 20px;
        text-align: center;
      }

      .right {
        width: 100%;
        margin: 0;
        margin-top: 5px;
        padding: 0;

        .rightContent {
          width: 100% !important;

          &.orderStatus_4 .detail {
            opacity: 1;
            color: #999999;
          }

          .detail {
            line-height: 38px;
            padding-left: 50px;
            font-size: 18px;

            .title {
              font-size: 20px;
              color: #333;
            }
          }

          .buttonsWarp {
            border-top: 1px dashed #0000001a;
            display: flex;
            justify-content: center;
            margin-top: 10px;
            padding: 0;

            &:after,
            &:before {
              background: #D9D9D9;
              width: 20px;
              height: 20px;
              top: -10px;
              left: -10px;
            }

            &:before {
              right: -10px;
              left: unset;
            }

            div {
              margin: 18px;
              width: 120px;
              letter-spacing: 0.1em;
              padding: 0;
            }
          }
        }
      }

      .orderStatus {
        font-size: 16px;
        line-height: 28px;
        height: 28px;
        width: 115px;
        top: 14px;
        right: 0;
        border-radius: 14px 0 0 14px;

        // border-top-left-radius: 14px;
        // border-bottom-left-radius: 14px;
        &.status_2 {
          background: #F2CCCC;
          color: #BE0000;
        }
      }
    }

    .personalCard:nth-child(2n-1) {
      margin-right: 4% !important;
    }
  }
}
</style>
